import HeaderBar from "./header/HeaderBar";
import Sidebar from "./sidebar/Sidebar";

import React, { useState } from "react";

const Common = (props) => {
  const { decodedToken } = props;
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <>
      <HeaderBar
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        decodedToken={decodedToken}
      />
      <Sidebar
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        decodedToken={decodedToken}
      />
    </>
  );
};

export default Common;
